import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_brands_settings: { message: "idle" },
};

export const retrieve_brands_settings_Slice = createSlice({
 name: "retrieve_brands_settings",
 initialState,
 reducers: {
  success_retrieve_brands_settings: (state, action) => {
   state.retrieve_brands_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_brands_settings: (state, action) => {
   state.retrieve_brands_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_brands_settings: (state) => {
   state.retrieve_brands_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_brands_settings: (state) => {
   state.retrieve_brands_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_brands_settings, fail_retrieve_brands_settings, reset_retrieve_brands_settings, loading_retrieve_brands_settings } = retrieve_brands_settings_Slice.actions;

export default retrieve_brands_settings_Slice.reducer;